"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePriceOffering = exports.parseAccessoryResponse = void 0;
var _constants = require("../../utils/constants");
const getProductSpecCharacteristicValue = (advancedPayment, name) => {
  return advancedPayment.prodSpecCharValueUse.find(el => el.name === name).productSpecCharacteristicValue[0];
};
const parsePriceOffering = variant => {
  const advancedPayment = variant.productOfferingPrice.find(el => el.priceType === _constants.PRICE_TYPES.ADVANCE_PAYMENT);
  const totalPrice = advancedPayment.price;
  const maxUpfront = getProductSpecCharacteristicValue(advancedPayment, 'maxUpFront');
  const minUpfront = getProductSpecCharacteristicValue(advancedPayment, 'minUpFront');
  const upfrontIncrementStep = getProductSpecCharacteristicValue(advancedPayment, 'paymentStep');
  const maxTerm = getProductSpecCharacteristicValue(advancedPayment, 'maxTerm');
  const minTerm = getProductSpecCharacteristicValue(advancedPayment, 'minTerm');
  const termIncrementStep = getProductSpecCharacteristicValue(advancedPayment, 'termStep');
  return {
    totalPrice,
    maxUpfront,
    minUpfront,
    upfrontIncrementStep,
    maxTerm,
    minTerm,
    termIncrementStep
  };
};
exports.parsePriceOffering = parsePriceOffering;
const getCharacteristicValue = (offering, characteristicName) => {
  var _offering$prodSpecCha;
  const characteristic = offering === null || offering === void 0 ? void 0 : (_offering$prodSpecCha = offering.prodSpecCharValueUse) === null || _offering$prodSpecCha === void 0 ? void 0 : _offering$prodSpecCha.find(char => char.name === characteristicName);
  if (characteristic) {
    var _characteristic$produ, _characteristic$produ2;
    const value = (_characteristic$produ = characteristic.productSpecCharacteristicValue[0]) === null || _characteristic$produ === void 0 ? void 0 : _characteristic$produ.value;
    const unitOfMeasure = (_characteristic$produ2 = characteristic.productSpecCharacteristicValue[0]) === null || _characteristic$produ2 === void 0 ? void 0 : _characteristic$produ2.unitOfMeasure;
    return unitOfMeasure ? `${value}|${unitOfMeasure}` : value;
  }
};
const parseAccessoryResponse = variantsData => {
  const selectionTree = {
    colors: {},
    sizes: {}
  };
  const variants = variantsData.map(variant => {
    const newVariant = {
      ...variant
    };
    newVariant.priceOffering = parsePriceOffering(variant);
    newVariant.color = getCharacteristicValue(variant, 'color');
    newVariant.size = getCharacteristicValue(variant, 'Screen Size');
    newVariant.media = variant.attachment;
    if (selectionTree.colors[newVariant.color]) {
      selectionTree.colors[newVariant.color].push(newVariant.size);
    } else {
      selectionTree.colors[newVariant.color] = [newVariant.size];
    }
    if (selectionTree.sizes[newVariant.size]) {
      selectionTree.sizes[newVariant.size].push(newVariant.color);
    } else {
      selectionTree.sizes[newVariant.size] = [newVariant.color];
    }
    return newVariant;
  });
  return {
    variants,
    selectionTree
  };
};
exports.parseAccessoryResponse = parseAccessoryResponse;